import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import { FSAction, GitAction } from './actions.enum';
import { FSRemoveEmptyDirsFn } from './fs-remove-empty-dirs';

export interface GitCheckoutAction extends WorkerAction {
  type: GitAction.Checkout;
  params: {
    branch?: string;
    create?: boolean;
    commitSha?: string;
    paths?: string[];
  };
}

class GitCheckoutActionError extends WorkerActionError {}

export async function GitCheckoutActionFn(params: WorkerFnParams<GitCheckoutAction>): Promise<void> {
  const { lg, util } = params;
  const { branch, create, commitSha, paths } = params.params;
  try {
    if (create && branch) {
      // passing commitSha allows us to create a branch from specific commit
      lg.callAndCaptureOutput(['checkout', '-b', branch, ...(commitSha ? [commitSha] : [])]);
    } else if (branch) {
      lg.callAndCaptureOutput(['checkout', branch]);
    } else if (commitSha && paths) {
      lg.callAndCaptureOutput(['checkout', commitSha, '--', ...paths]);
    } else if (paths) {
      lg.callAndCaptureOutput(['checkout', '--', ...paths]);
    }

    // Clean up any empty folders
    await FSRemoveEmptyDirsFn({ ...params, params: { type: FSAction.RemoveEmptyDirs } });
    await util.syncfs(false);
  } catch (err) {
    throw new GitCheckoutActionError(err);
  }
}
